import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  DevicePhoneMobileIcon,
  TagIcon,
  CubeIcon,
  UserGroupIcon,
  BuildingOffice2Icon,
} from "@heroicons/react/24/outline";
import { getUser } from "../../../utils/storage";
import Button from "../../../components/Button";
import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "../../../utils/axios";
import { ArrowLeftIcon } from "@heroicons/react/20/solid";

const TRASH_TYPES = [
  {
    type: "devices",
    label: "Devices",
    icon: DevicePhoneMobileIcon,
    variant: "outline-success",
  },
  { type: "brands", label: "Brands", icon: TagIcon, variant: "outline-orange" },
  {
    type: "models",
    label: "Models",
    icon: CubeIcon,
    variant: "outline-purple",
  },
  {
    type: "users",
    label: "Users",
    icon: UserGroupIcon,
    variant: "outline-info",
  },
  {
    type: "clients",
    label: "Clients",
    icon: BuildingOffice2Icon,
    variant: "outline-danger",
  },
];

export default function TrashCategories() {
  const navigate = useNavigate();
  const { type: currentType } = useParams();
  const user = getUser();

  const { data, isLoading } = useQuery({
    queryKey: ["deleted-counts"],
    queryFn: async () => {
      const response = await axiosInstance.get(
        `${window.REACT_APP_API_ENDPOINT}/trash/deleted-counts`
      );
      return response.data.data;
    },
  });

  return (
    <div className="px-4 sm:px-6 lg:px-8 bg-bgBlue">
      <div className="sm:flex flex-col sm:items-start">
        <div className="w-full flex justify-between py-4 px-4 bg-white rounded-lg">
          <h3 className="font-bold text-2xl">👋 Hello {user.name}</h3>
        </div>
      </div>
      <div className="w-full flex flex-col  mt-16 mb-16">
        <h1 className="text-3xl font-extrabold text-bluePrimary mb-3 tracking-tight ">
          Trash Categories (Super Admin)
        </h1>
        <p className="text-gray-600 mb-8  max-w-lg">
          Select a category below to view and manage deleted items. You can
          restore or permanently delete items from each category.
        </p>
        <div className="flex-col flex lg:flex-row gap-4 ">
          {TRASH_TYPES.map(({ type, label, icon: Icon, variant }) => (
            <Button
              key={type}
              onClick={() => navigate(`/admin/trash/${type}`)}
              variant={variant}
              size="lg"
              icon={<Icon className="h-6 w-6 mr-2" />}
              className={` relative ${currentType === type ? "scale-105" : ""}`}
            >
              <span className="flex items-center justify-between w-full">
                {label}
                <span
                  className={`ml-2 inline-flex items-center justify-center rounded-full text-xs font-bold px-2 py-0.5
                    ${
                      variant === "outline-success"
                        ? "bg-green-100 text-green-700"
                        : variant === "outline-orange"
                        ? "bg-orange-100 text-orange-700"
                        : variant === "outline-purple"
                        ? "bg-purple-100 text-purple-700"
                        : variant === "outline-info"
                        ? "bg-blue-100 text-blue-700"
                        : variant === "outline-danger"
                        ? "bg-red-100 text-red-700"
                        : "bg-gray-100 text-gray-700"
                    }
                  `}
                >
                  {isLoading ? (
                    <span className="inline-block w-3 h-3 animate-spin border-2 border-blue-400 border-t-transparent rounded-full"></span>
                  ) : (
                    data?.[type] ?? 0
                  )}
                </span>
              </span>
            </Button>
          ))}
        </div>
      </div>
    </div>
  );
}
